<script>
    import { createEventDispatcher } from 'svelte';
    import Modal from "../atoms/Modal.svelte";
    import Container from "../atoms/Container.svelte";
    import Button from "../atoms/Button.svelte";

    const dispatch = createEventDispatcher();

    export let label = "Dialogue";
    export let cancel = false;

    function handleClose() {
        dispatch("close");
    }

    function handleOkay() {
        dispatch("close");
        dispatch("okay");
    }

    function handleCancel() {
        dispatch("close");
        dispatch("cancel");
    }
</script>

<Modal on:close={handleClose}>
    <div class="center">
        <div on:click="{e => e.stopPropagation()}" class="dialogue">
            <Container br="0.4rem" height={2}>
                <slot></slot>
                <div class="bottom-bar">
                    {#if cancel}
                        <Button 
                            on:click={handleCancel}
                            label="Cancel" 
                            bg="red"/>
                    {/if}
                    <div style="width: 0.6rem"></div>
                    <Button 
                        on:click={handleOkay}
                        label="Okay"
                        bg="blue"/>
                </div>
            </Container>
        </div>
    </div>
</Modal>

<style>
    .dialogue {
        width: calc(100% - 2rem);
    }

    @media only screen and (min-width: 768px) {
        .dialogue {
            max-width: 26rem;
            width: 50%;
        }
    }

    .bottom-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }

    .center {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
</style>
